import { Link, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { categories } from "@/mocks/forum";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb() {
  const location = useLocation();

  const breadcrumbs: BreadcrumbItem[] = useMemo(() => {
    const items: BreadcrumbItem[] = [{ label: "首页", path: "/" }];
    const pathParts = location.pathname.split("/").filter(Boolean);

    if (pathParts[0] === "category" && pathParts[1]) {
      const cat = categories.find((c) => c.slug === pathParts[1]);
      items.push({ label: cat ? cat.name : "分类浏览", path: `/category/${pathParts[1]}` });
    }

    if (pathParts[0] === "article" && pathParts[1]) {
      items.push({ label: "文章详情" });
    }

    if (pathParts[0] === "about") {
      items.push({ label: "关于我们", path: "/about" });
    }

    return items;
  }, [location.pathname]);

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {breadcrumbs.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.path && index < breadcrumbs.length - 1 ? (
              <Link
                to={item.path}
                className="hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === breadcrumbs.length - 1 ? "text-foreground-800 font-medium" : ""}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}